import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgGoToTop({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 10.415L5.707 15.71a1 1 0 11-1.414-1.414l7-7.003a1 1 0 011.448.035l6.966 6.968a1 1 0 11-1.414 1.414L13 10.416v9.585a1 1 0 11-2 0v-9.586zM5 3h14a1 1 0 110 2H5a1 1 0 010-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgGoToTop
